import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#bb0000",
    },
    secondary: {
      main: "#ffffff", 
    },
    background: {
      default: "#F5F5F5", 
    },
    text: {
      primary: "#333", 
    },
  },
  typography: {
    fontFamily: "sans-serif", 
    fontSize: 12, 
    h4: {
      fontWeight: 700,
      color: "#0a0a0a",
    },
    h6: {
      color: "#1d1e1f", 
    },

    body1: {
      fontSize: "0.875rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
    subtitle1: {
      fontSize: "0.875rem",
    },
  },
});

export default theme;
